define([
	"dojo/_base/declare",
	"csi/heading/RefFilterController",
	"csi/prefs/BrowseAttributesStoreOptions"
], function(declare, RefFilterController, BrowseAttributesStoreOptions) {

	return declare(BrowseAttributesStoreOptions,
		{
			attributesMap: null,

			constructor: function(/*Object*/productTypeAttributesMap) {
				var m = {};
				for (var key in productTypeAttributesMap) {
					// strip everything before the slash
					var index = key.indexOf("/");
					if (index >= 0)
						key = key.substring(index + 1);
					m[key] = true;
				}
				this.attributesMap = m;
			},

			filterItem: function(item) {
				var result = this.inherited(arguments);
				if (result) {
					// filter out optional attributes not belonging to our material type
					var ra = item.ra;
					if (ra && ra.isOptional) {
						if (!this.attributesMap[ra.getId()])
							result = false;
					}
				}
				return result;
			}
		}
	);
});